import { ENTITY_TYPES } from '@sales-center/common'
import { selectAllCustomFieldsSettings } from '@user/store/customFieldSettings'
import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { addLeadSectionLabels, addOppSectionLabels } from '../constants'

export const useGetEntityFormDataOnMount = (
  entityType: ENTITY_TYPES,
  hideOptional?: boolean,
) => {
  const settings = useSelector(selectAllEntityFormSettings)
  const customFieldSettings = useSelector(selectAllCustomFieldsSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [settingsBySection] = useMemo(() => {
    const settingsBySection = {}
    Object.keys(
      entityType === ENTITY_TYPES.Lead
        ? addLeadSectionLabels
        : addOppSectionLabels,
    ).map(
      (x) =>
        (settingsBySection[x] = settings.filter(
          (y) => y.entityType === entityType && y.sectionId == x,
        )),
    )

    return [settingsBySection]
  }, [settings, entityType])

  const requiredEntitySettings = useMemo(() => {
    return settings.filter(
      (x) => x.entityType === entityType && x.required && !x.systemRequired,
    )
  }, [settings, entityType])

  const requiredCustomSettings = useMemo(() => {
    return customFieldSettings.filter((x) => x.required)
  }, [customFieldSettings])

  const anyEnabledCustomField = useMemo(() => {
    return customFieldSettings.some((x) => x.enabled)
  }, [customFieldSettings])

  return {
    settingsBySection,
    requiredEntitySettings,
    requiredCustomSettings,
    entitySettingsMap,
    anyEnabledCustomField,
    customFieldSettings,
    settings,
  }
}
